/**
 * Shared recipe-ingredient unit helpers (add-pos-recipes-and-cups §3) — used by
 * both the standalone Recipes workspace and the in-catalogue recipe editor so
 * the two never drift. Amounts are in BASE units, matching the backend:
 * LITERS → mL, GRAMS → g, COUNT → whole units.
 */

import type { RecipeIngredientIn } from "../api/client";

export type RecipeUnitType = RecipeIngredientIn["unit_type"];

/** The base unit each ``unit_type`` measures (the ingredient ``amount`` is in
 * these units). */
export const UNIT_LABEL: Record<RecipeUnitType, string> = {
  liters: "mL",
  grams: "g",
  count: "units",
};

export const UNIT_OPTIONS: { value: RecipeUnitType; label: string }[] = [
  { value: "liters", label: "mL (volume)" },
  { value: "grams", label: "g (weight)" },
  { value: "count", label: "units (count)" },
];

/** Map an article's effective unit_type (override wins) to a recipe ingredient
 * unit_type, so picking a consumable defaults its unit sensibly. */
export const defaultUnitType = (
  unitType?: string | null,
  unitTypeOverride?: string | null,
): RecipeUnitType => {
  const t = (unitTypeOverride ?? unitType ?? "").toLowerCase();
  if (t === "liters") return "liters";
  if (t === "grams") return "grams";
  return "count";
};
